module.exports = __webpack_public_path__ + "img/jui_triangles.26810947.png";